<template>
  <modal
    title="Add Collection Account"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="input-wrapper my-2">
      <label for="bussiness" class="">Bussiness Name</label>
      <input
        type="text"
        id="bussiness"
        class="input"
      />
    </div>
    <div class="input-wrapper my-2">
      <label for="bank" class="">Bank</label>
      <input
        type="text"
        id="bank"
        class="input"
      />
    </div>
    <div class="input-wrapper my-2">
      <label for="acct_no" class="">Account Number</label>
      <input
        type="text"
        id="acct_no"
        class="input"
      />
    </div>
    <div class="input-wrapper my-2">
      <label for="acct_name" class="">Account Name</label>
      <input
        type="text"
        id="acct_name"
        class="input"
      />
      <div class="flex justfy between">
        <p>Scello Nigeria -.</p>
        <span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 0.625L5.875 13.4063L2.5 10.8438H0.625L5.875 19.375L19.375 0.625H17.5Z" fill="#09B78A"/>
            </svg>
        </span>
      </div>
    </div>

    <hr/>

    <p class="text-primary-yellow cursor-pointer">
        + Add Account
    </p>

    <div class="button-wrapper mt-5">
      <primary-button buttonText="Save"/>
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Close</p>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
     
    };
  },
  methods:{
    closeModal() {
      this.$emit("close-modal");
    }
  }
};
</script>
